<template>
  <div class="goodsdetail1">
    <!--头部导航-->
    <top-nav1 ref="TopNav1"></top-nav1>
    <van-nav-bar style="background: #f1f1f1" title="产品详情" fixed left-arrow @click-left="goBack">
      <van-icon slot="right" @click="onClickRight" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div style="padding: 56px 0" class="van-content" v-if="datas != ''">
      <!--banner-->
      <div class="bg-fff" style="padding: 15px">
        <van-swipe class="radius6" :autoplay="3000">
          <van-swipe-item v-for="items in banner" :key="items.id">
            <img width="100%" :src="items" onerror="src='/static/errorimg1.png'" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <!--商品信息-->
      <van-cell-group class="goodsName" style="margin-bottom: 0">
        <van-cell>
          <template slot="title">
            <div class="van-cell-text ellipseal">
              <span plain class="jd1" v-if="datas.source == 1">优选</span>
              <span class="yx1" v-if="datas.source == 6">严选</span>
              {{ datas.name }}
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="goodsName" style="margin-bottom: 0">
        <div
          style="color: #ccc; font-size: 14px; padding: 0 15px"
          v-if="$store.state.exchangeinfo.market_status == 1"
        >
          市场价:{{ datas.market_price }}元
        </div>
      </van-cell-group>
      <!--商品详情-->
      <van-cell-group style="margin-bottom: 0">
        <div class="van-cell ft15" style="font-weight: bold; padding-bottom: 0">商品详情</div>
        <div style="padding: 5px 15px 15px 15px" class="van-cell">
          <span class="dot theme-bg"></span>
        </div>
      </van-cell-group>
      <div v-if="datas.content_wap != ''" v-html="datas.content_wap" class="clear goodstab">
        {{ datas.content_wap }}
      </div>
      <div v-if="datas.content_wap == ''" style="text-align: center; padding: 20px 0">
        暂无详情信息!
      </div>
    </div>
    <!--无货-->
    <!--<van-goods-action class="down"   v-if="datas.status ==0 ">-->
    <!--<span>已下架</span>-->
    <!--</van-goods-action>-->
    <!--底部-->
    <van-goods-action style="box-shadow: 0px 0px 2px 1px #f2f2f2">
      <!-- <van-goods-action-big-btn   :class="!disabled?'theme-bg theme-bd':''" text="兑换" @click="showCustom"/> -->
      <div :class="!disabled ? 'btn' : 'hui'" @click="showCustom">兑换</div>
    </van-goods-action>
  </div>
</template>

<script>
import CityPicker from '@/pages/user/mysite/cityPicker'
import TopNav1 from '../../components/topnav1'
import store from '../../vuex/store'
export default {
  name: 'detail',
  components: {
    CityPicker,
    TopNav1
  },
  store,
  computed: {
    unit: function () {
      return this.$store.state.unitinfo.name
    }
  },
  data() {
    return {
      disabled: false,
      datas: '',
      banner: '',
      id: this.$route.query.id, //商品id
      got: false,
      gid: this.$route.query.gid
    }
  },

  methods: {
    onClickRight() {
      this.$refs.TopNav1.topnavPlay()
    },
    cityPickershow: function () {
      this.$refs.CityPicker.cityPickershow()
    },
    goBack: function () {
      this.$router.push({ name: 'Eindex', query: { gid: this.gid } })
    },
    getDatas: function () {
      var mallid = localStorage.getItem('mallid')
      var isUser = localStorage.getItem('ECuser')
      var userid = localStorage.getItem('user_id')
      var gid = localStorage.getItem('gid')
      this.$api.get(
        '/active/product/information',
        { id_active: this.gid, id_product: this.id },
        res => {
          if (res.data.code == '100') {
            this.datas = res.data.data
            this.banner = res.data.data.image
            this.stockid = res.data.data.id_product
          } else {
            this.$toast(res.data.message)
          }
        },
        err => {
          this.$toast('服务器繁忙，请稍后再试')
        }
      )
    },
    check: function () {
      //检查是否已兑换
      var isUser = localStorage.getItem('ECuser')
      var gid = localStorage.getItem('gid')
      this.$api.get(
        'active/order/check',
        { id_active: this.gid, token_user: isUser },
        res => {
          if (res.data.data.result == 0) {
            this.got = true
          }
        },
        err => {
          this.$toast('服务器繁忙，请稍后再试')
        }
      )
    },
    // 底部立即购买
    showCustom: function () {
      var isUser = localStorage.getItem('ECuser')
      var mallid = localStorage.getItem('mallid')
      var gid = localStorage.getItem('gid')
      if (isUser != undefined) {
        if (this.got == false) {
          //已兑换就不能兑换了
          this.$api.post(
            'active/order/create',
            {
              id_active: this.gid,
              token_user: isUser,
              id_product: this.id
            },
            res => {
              if (res.data.code == '100') {
                var id_cart = res.data.data.id_order.toString()
                this.$router.push({ path: '/eordercomit', query: { id: id_cart, gid: this.gid } })
              } else {
                if (res.data.message == 'token验证失败') {
                  this.$dialog
                    .confirm({
                      title: '提示 ',
                      message: '您还未登录是否去登录？'
                    })
                    .then(() => {
                      this.$router.push({ name: 'Elogin', query: { gid: this.gid } })
                    })
                    .catch(() => {})
                } else {
                  this.$toast(res.data.message)
                }
              }
            },
            err => {
              this.$toast('服务器繁忙，请稍后再试')
            }
          )
        } else {
          this.$toast('已经兑换，不能重复兑换')
        }
      } else {
        this.$dialog
          .confirm({
            title: '提示 ',
            message: '您还未登录是否去登录？'
          })
          .then(() => {
            this.$router.push({ name: 'Elogin', query: { gid: this.gid } })
          })
          .catch(() => {})
      }
    }
  },
  mounted() {
    this.getDatas()
    this.check()
    $('body').css('background', '#fff')
    var isUser = localStorage.getItem('ECuser')
    if (isUser == null) {
      setTimeout(() => {
        this.$store.state.exchangeinfo.tourist == 0
          ? this.$router.push({ name: 'Eguide', query: { gid: this.gid } })
          : true
      }, 500)
    }
  },
  destroyed: function () {
    $('body').css('background', '#EFF3F6')
  }
}
</script>
<style lang="less">
.goodsdetail1 {
  .van-hairline--bottom.van-nav-bar.van-nav-bar--fixed .van-nav-bar__title {
    text-align: center;
    font-weight: bold;
  }
  .van-nav-bar {
    .van-icon {
      font-size: 0.4rem !important;
    }
  }
  .dot {
    display: inline-block;
    width: 22px;
    height: 4px;
    background: #7966fe;
    border-radius: 2px;
  }
  .down {
    box-shadow: 0px 0px 2px 1px #f2f2f2;
    bottom: 51px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #999 !important;
    color: #fff;
    span {
      display: inline-block;
      width: 100%;
      text-align: center;
    }
  }
  [class*='van-hairline']:after {
    border: none;
  }
  .noMargin {
    margin: 0 !important;
  }

  .van-button--warning {
    border: none;
  }
  .van-goods-action {
    z-index: 100;
    background: #fff;
    padding: 0 20px 10px 20px;
  }
  .van-button--large {
    width: 50%;
    height: 40px;
    line-height: 40px;
    margin: 5px;
    border-radius: 6px;
    background: linear-gradient(left, #ef5033, #ff397a) !important;
    background: -webkit-linear-gradient(left, #ef5033, black) !important;
    background: -o-linear-gradient(left, #ef5033, black) !important;
    background: -moz-linear-gradient(left, #ef5033, black) !important;
    background: -ms-linear-gradient(left, #ef5033, #ff397a) !important;
  }
  .van-goods-action-mini-btn {
    min-width: 22%;
  }
  .goodsName {
    .ellipseal {
      height: auto;
      font-size: 0.32rem;
      font-weight: bolder;
      line-height: normal !important;
    }
  }
  .van-sku-container {
    overflow: inherit;
  }

  .van-stepper__input {
    vertical-align: top;
  }
  .van-hairline--top-bottom::after {
    border-width: 0;
  }
  .van-cell:not(:last-child)::after {
    border-bottom-width: 0;
  }
  .van-tabs {
    z-index: 0;
    background: #fff;
  }
  .van-cell-group,
  .van-cell {
    background-color: #fff;
  }
  .van-button--bottom-action {
    line-height: 48px;
  }
  .tabtop .van-tabs__wrap--content-top {
    position: fixed;
    top: 44px;
  }
  .goodstab {
    padding: 0 0.3rem;
    background-color: #fff;
  }
  .goodstab span {
    white-space: normal !important;
  }
  .goodstab img {
    width: 100%;
    height: auto !important;
  }
  .goodstab table,
  .goodstab tr {
    width: 100% !important;
    height: auto !important;
  }
  .goodstab div {
    width: 100% !important;
  }
  .goodstab div,
  .goodstab p {
    zoom: 1;
  }
  .goodstab div:before,
  .goodstab p:before,
  .goodstab div:after,
  .goodstab p:after {
    display: table;
    content: '';
    line-height: 0;
  }
  .goodstab div:after,
  .goodstab p:after {
    clear: both;
  }

  .btn {
    width: 98%;
    height: 0.8rem;
    margin: 0 auto;
    background-color: red !important;
    border-radius: 0.08rem;
    color: #fff;
    text-align: center;
    line-height: 0.8rem;
    margin-top: 10px;
  }

  .hui {
    width: 98%;
    height: 0.8rem;
    margin: 0 auto;
    background-color: rgba(189, 189, 189, 0.596) !important;
    border-radius: 0.08rem;
    color: #fff;
    text-align: center;
    line-height: 0.8rem;
    margin-top: 10px;
  }
}
.theme-bg,.van-checkbox--checked,.van-swipe__indicator--active{background-color:red!important;color:#ffffff!important}
.theme-col,.van-icon-checked{color: red!important;}
.col-hover:hover{color: red!important;}
.col-on{color: red!important;}
.col-focus:focus{color: red!important;}
.col-checked:checked:before{
  color: red!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/exchange/detail.vue